'use client';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

// ページ遷移時のフェードイン
export default function Template({ children }: { children: ReactNode }) {
  return (
    <motion.div
      className="site-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: 'linear', duration: 1 }}
    >
      {children}
    </motion.div>
  );
}
